<template>
  <router-view name="InvoiceView"></router-view>
</template>
<script>
export default {
  name: "InvoiceHome",
};
</script>
<style scoped></style>
